import React, { useState, useContext, useEffect } from 'react';
import { Button, Divider, Form, FormField, Header, Icon, Image, Input, Message, MessageContent, MessageHeader, Segment } from 'semantic-ui-react'

import tchtg from '../../../../assets/tchtg.png';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import { checkDateOnlyStartBeforeNow, getlinktournament, mobileWSmall } from '../../../../myfunctions';
import { ConnectWS } from '../../../../ConnectWS';
import AuthContext from '../../../../context/authContext';


function TurniejCharytatywny() {
  const { width, height } = useWindowDimensions();// eslint-disable-line no-unused-vars
  const authContext = useContext(AuthContext);
  const [form, setForm] = useState({
    user_mail: null,
    tournament_name: null,
    tournament_url: null,
  });

  const [messageStatus, setmessageStatus] = useState({
    error: null,
    message: "",
  });

  const [loading, setloading] = useState(false);

  const [Tournament, setTournament] = useState([]);// eslint-disable-line no-unused-vars

  useEffect(() => {
    if (authContext.user) {
      setForm({ ...form, user_mail: authContext.user.email })
      getTournaments()
    }

    return () => { }; // use effect cleanup to set flag false, if unmounted
  }, [authContext.user]);// eslint-disable-line react-hooks/exhaustive-deps


  const submit = async e => {
    e.preventDefault();

    if(form.tournament_name===null){
      setmessageStatus({ error: true, message: "Proszę wybrać turniej" })
      return 
    }
    setloading(true)
    setmessageStatus({ error: null, message: "" })
    console.log(form)
    let email = form.user_mail
    let tournament_id = JSON.parse(form.tournament_name).tournament_id
    let tournament_url = form.tournament_url

    ConnectWS("/generator/sendNotifyCharityTournament ", authContext.token, { email:email,tournament_id:tournament_id,tournament_url:tournament_url }, function (response, logout) {
      if (logout === 1) {
      } else if (response && response.status && Number(response.status) === 200) {
        setmessageStatus({ error: false, message: response.data.message })
        setForm({ ...form, tournament_url: "" })
      } else {
        setmessageStatus({ error: true, message: response })
        console.log(response);
      }
      setloading(false)
    });
    

  }

  function getFormData() {
    return <Message warning>
      1. Należy utworzyć konto w systemie turniej-generator.pl<br />
      2. Utworzyć darmowy turniej uzupełniając wszystkie informacje (nazwa lub opis turnieju muszą zawierać wyraźną informację, że jest to wydarzenie charytatywne!)<br />
      3. Wysłać zgłoszenie przez poniższy formularz.<br />
    </Message>
  }



  function getTournaments() {

    ConnectWS("/generator/getTournaments", authContext.token, {}, function (response, logout) {

      if (logout === 1) {

      } else if (response && response.status && Number(response.status) === 200) {

        let dictemat = []
        dictemat.length = 0
        response.data.forEach((data, i) => {
          if ((checkDateOnlyStartBeforeNow(data.start_date))) {
            dictemat.push({ key: i, text: data.name + " - " + data.start_date, value: JSON.stringify({ tournament_id: data.tournament_id, tournament_name: data.name }) })
          }
        })
        //setRowDataTournament(response.data)
        setTournament(dictemat);
      } else {

      }



    });
  }

  return (
    <>

      <Segment textAlign={width < mobileWSmall() ? 'center' : "left"} style={{height:280}}>
        {width < mobileWSmall() ? <Image src={tchtg} centered alt="logo" /> : <Image src={tchtg} floated='left' alt="logo" />}
        <p>
          <b>Turniej-Generator.pl</b> wychodzi na przeciw wszystkim, którzy organizują wszelkiego rodzaju turnieje charytatywne.
          Chętnie chcemy się włączyć w akcje, których celem jest dobro innych. <b> Dla wydarzeń charytatywnych umożliwiamy skorzystanie z aplikacji za darmo w najwyższym pakiecie</b>,
          który znosi wszystkie ograniczenia.
          <br />  Oferujemy także wsparcie krok-po-kroku osobom, które organizując turniej w naszej aplikacji będą to robiły pierwszy raz.
        </p>
        <p>
          Jeśli jesteś organizatorem turnieju charytatywnego to powiadom nas o tym:
        </p>
    
      </Segment>
      <div> {getFormData()}</div>
      {authContext.user ?
        <Segment className='modalBGcolor' >
          <Header>
            FORMULARZ:
          </Header>
          {messageStatus.error != null ?
            <Message success={!messageStatus.error} error={messageStatus.error} icon>
              <Icon name='info circle' />
              <MessageContent>
                {messageStatus.message}
              </MessageContent>
            </Message>
            : ""}
          <Form size='tiny' onSubmit={submit}>
            <FormField
              control={Input}
              label='Adres email użyty do utworzenia konta w TG'
              value={form.user_mail}
              onChange={(e, d) => setForm({ ...form, user_mail: d.value })}
              required={true}
              readOnly
              placeholder='Adres email użyty do utworzenia konta w TG'
            />
            <Form.Select
              fluid
              search
              label={"Proszę wybrać turniej"}
              options={Tournament}
              value={form.tournament_name}
              required={true}
              onChange={(e, d) => setForm({ ...form, tournament_name: d.value })}
              placeholder='Proszę wybrać...'
            />


            <FormField
              control={Input}
              label='Link do wydarzenia, postu na FB, link do strony www, lub link do plakatu'
              value={form.tournament_url}
              onChange={(e, d) => setForm({ ...form, tournament_url: d.value })}
              required={true}
              type='url'
              placeholder='Link do wydarzenia, postu na FB, link do strony www, lub link do plakatu'
            />
            {form.tournament_name ?
              <div style={{ marginTop: 5, marginBottom: 10 }}>
                <Divider />
                Link do turnieju w TG: {getlinktournament(JSON.parse(form.tournament_name).tournament_id,1)} <br />
                Prosimy o skopiowanie powyższego linku i umieszczenie go w swoim ogłoszeniu na FB lub innym portalu.
              </div> : ""}
            <Button disabled={loading} loading={loading} type='submit' fluid>Wyślij zgłoszenie do weryfikacji</Button>
          </Form>
        </Segment>
        : <Message icon warning>
          <Icon name='info circle' />
          <MessageContent>
            <MessageHeader>Brak zalogowania do systemu</MessageHeader>
            Proszę zalogować się do systemu. Wówczas pojawi się formularz do wypełnienia.
          </MessageContent>
        </Message>}
    </>


  )
}

export default TurniejCharytatywny;